export interface Domain {
  id: string;
  name: string;
  symbol?: string;
  channel_id?: string;
  description?: string;
  created_at?: string;
}

/**
 * Deduplicate domains by name, preferring general domains (no channel_id)
 * over channel-specific ones. Logs any duplicates found.
 */
export const deduplicateDomains = (domains: Domain[]): Domain[] => {
  const duplicateNames = new Set<string>();
  const seen = new Set<string>();
  
  // First pass: identify duplicates
  domains.forEach(domain => {
    if (seen.has(domain.name)) {
      duplicateNames.add(domain.name);
    }
    seen.add(domain.name);
  });
  
  // Log duplicates for debugging
  if (duplicateNames.size > 0) {
    console.warn(`Found ${duplicateNames.size} duplicate domain names:`, Array.from(duplicateNames));
    duplicateNames.forEach(name => {
      const dupes = domains.filter(d => d.name === name);
      console.warn(`  - "${name}": ${dupes.length} entries`, dupes.map(d => ({
        id: d.id,
        channel_id: d.channel_id || 'general'
      })));
    });
  }
  
  // Second pass: deduplicate
  const uniqueDomains = domains.reduce((acc, domain) => {
    const existing = acc.find(d => d.name === domain.name);
    
    if (!existing) {
      acc.push(domain);
    } else if (!domain.channel_id && existing.channel_id) {
      // Replace channel-specific with general domain
      const index = acc.findIndex(d => d.name === domain.name);
      acc[index] = domain;
    }
    // If both have channel_id or both don't, keep the first one
    
    return acc;
  }, [] as Domain[]);
  
  return uniqueDomains;
};

